import { CourseContent, CourseContentType } from '@/client/courses';
import { QuizType } from '@/client/quizzes';
import { containsScormModule } from '@/utils/helpers/courses.helper';

export type ModuleCompletionDecision = {
  persist: 'quiz-score' | 'attempt' | null;
  navigate: 'dashboard' | 'next' | null;
};

export const decideModuleCompletion = (
  modules: CourseContent[],
  currentModuleIndex: number,
  isLastModuleCompletable: boolean,
): ModuleCompletionDecision => {
  const currentModule = modules[currentModuleIndex];
  const isLastModule = currentModuleIndex === modules.length - 1;
  const hasScormModule = containsScormModule(modules);
  const hasTraditionalQuiz = modules.some(
    (module) => module.quiz?.type === QuizType.TRADITIONAL,
  );

  let persist: ModuleCompletionDecision['persist'] = null;

  if (currentModule?.quiz?.type === QuizType.TRADITIONAL && !hasScormModule) {
    persist = 'quiz-score';
  } else if (
    isLastModuleCompletable &&
    !hasScormModule &&
    !hasTraditionalQuiz
  ) {
    persist = 'attempt';
  }

  let navigate: ModuleCompletionDecision['navigate'] = null;

  if (isLastModule && currentModule?.type !== CourseContentType.QUIZ) {
    navigate = 'dashboard';
  } else if (isLastModuleCompletable && !isLastModule) {
    navigate = 'next';
  }

  return { persist, navigate };
};
